import { useQuery } from '@tanstack/vue-query';
import { computed, type Ref } from 'vue';
import { getProductosMasVendidosAction } from '../actions';

export function useProductosMasVendidosQuery(limit: Ref<number> | number = 10) {
  const limitValue = typeof limit === 'number' ? limit : limit.value;

  const query= useQuery({
    queryKey: [ 'productos-mas-vendidos', limitValue],
    queryFn: async () => {
      const response = await getProductosMasVendidosAction(limitValue);
      return response.data;
    },
    refetchInterval: 60000, // Refetch cada minuto
    staleTime: 45000,
    placeholderData: (previousData) => previousData
  });
  const productosVendidosData = computed(() => query.data?.value);
  return {
    productosVendidosData,
   ...query,
  };
}